import { FC, ReactNode, MouseEvent, FormEvent } from 'react';
import { CircularProgress } from '@mui/material';
import {
  StyledDialog,
  RelativePositionBox,
  CloseIcon,
  FormContentBox,
  ButtonContainer,
  CancelButton,
  BorderedSectionBox,
  SectionTitleTypography,
  HeaderBoxSimple,
  TitleTypographyLarge,
  SubtitleTypographySimple,
  SubmitButton,
  ScrollableFormContent,
  FormContainer,
  StyledCircularProgress,
  ButtonContainerAddGrnPay,
} from './GRNPaymentDialog.styles';

interface AddGRNPaymentDialogProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  subtitle: string;
  children: ReactNode;
  onSubmit: (e?: FormEvent<HTMLFormElement>) => void;
  buttonLabel?: string;
  buttonDisabled?: boolean;
  onSaveClick?: () => void;
  paymentModeSection?: ReactNode;
}

const AddGRNPaymentDialog: FC<AddGRNPaymentDialogProps> = ({
  open,
  handleClose,
  title,
  subtitle,
  children,
  onSubmit,
  buttonLabel = 'Save',
  buttonDisabled,
  onSaveClick,
  paymentModeSection,
}) => {
  const handleSave = (e: MouseEvent) => {
    e.preventDefault();
    onSaveClick?.();
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <RelativePositionBox>
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </RelativePositionBox>
      <HeaderBoxSimple>
        <TitleTypographyLarge>{title}</TitleTypographyLarge>
        <SubtitleTypographySimple>{subtitle}</SubtitleTypographySimple>
      </HeaderBoxSimple>
      <FormContainer onSubmit={onSubmit}>
        <ScrollableFormContent>
          <FormContentBox>{children}</FormContentBox>
          {paymentModeSection && (
            <BorderedSectionBox>
              <SectionTitleTypography>Payment Method</SectionTitleTypography>
              {paymentModeSection}
            </BorderedSectionBox>
          )}
          <ButtonContainerAddGrnPay>
            <SubmitButton
              type="button"
              disabled={buttonDisabled}
              onClick={handleSave}
            >
              {buttonDisabled ? (
                <StyledCircularProgress>
                  <CircularProgress size={20} />
                </StyledCircularProgress>
              ) : (
                buttonLabel
              )}
            </SubmitButton>
            <CancelButton type="button" onClick={handleClose}>
              Cancel
            </CancelButton>
          </ButtonContainerAddGrnPay>
        </ScrollableFormContent>
      </FormContainer>
    </StyledDialog>
  );
};

export default AddGRNPaymentDialog;
